
  <nb-card class="bottom-modal purple-pink-card">
    <nb-icon class="close" icon="close" (click)="dismiss()"></nb-icon>
    <nb-card-body class="justify-content-start px-1 pt-0">

      <div class="section-header mt-0 mb-2 w-100 justify-content-start mx-0">
        <h6 class="section-title">Quality</h6>
      </div>
      <nb-button-group outline class="w-100" (valueChange)="updateValue($event, 'quality')">
        <button *ngFor="let button of qualityButtons" [value]="button.value" [pressed]="button.value == setValue.quality" nbButtonToggle class="w-100" nbButton size="small" shape="round"  status="primary">
          {{button.name}}
        </button>
      </nb-button-group>

      <div class="section-header mt-1 mb-2 w-100 justify-content-start mx-0">
        <h6 class="section-title mt-2">Initiator</h6>
      </div>
      <nb-button-group outline class="w-100" (valueChange)="updateValue($event, 'initiator')">
        <button *ngFor="let button of initiatorButtons" [value]="button.value" [pressed]="(button.value == setValue.initiator)" nbButtonToggle class="w-100" nbButton size="small" shape="round"  status="primary">
          {{button.name}}
        </button>
      </nb-button-group>

      <div class="section-header mt-1 mb-2 w-100 justify-content-start mx-0 w-100">
        <h6 class="section-title mt-2">Medium</h6>
      </div>
      <nb-button-group outline class="mb-2 w-100" (valueChange)="updateValue($event, 'medium')">
        <button *ngFor="let button of mediumButtons" [value]="button.value" [pressed]="button.value == setValue.medium" nbButtonToggle class="w-100" nbButton size="small" shape="round"  status="primary">
          {{button.name}}
        </button>
      </nb-button-group>

      <div class="section-header mt-1 mb-2 w-100 justify-content-start mx-0">
        <h6 class="section-title mt-0">Date</h6>
      </div>
      <nb-button-group outline class="mb-2 w-100" (valueChange)="updateValue($event, 'date')">
        <button *ngFor="let button of dateButtons" [value]="button.value" [pressed]="button.value == setValue.date" nbButtonToggle class="w-100" nbButton size="small" shape="round" status="primary">
          {{button.name}}
        </button>
      </nb-button-group>

      <div *ngIf="setValue.date === 'custom'" class="custom-date-container">
        <div class="selected-date" *ngIf="customDate">
          Selected: {{customDate | date:'MMM d, y'}} 
          <button (click)="toggleCalendar()"  nbButton ghost class="text-light" shape="round"><nb-icon icon="arrow-ios-downward-outline"></nb-icon></button>

        </div>

        <nb-accordion>
          <nb-accordion-item #item>
            <nb-accordion-item-body class="m-0">
              <ion-datetime 
                presentation="date" 
                [preferWheel]="false"
                [value]="customDate"
                (ionChange)="onCustomDateChange($event)"
                color="custom-calendar"
                >
              </ion-datetime>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>

      </div>

      <div class="d-flex w-100 align-items-center">
        <button *ngIf="connection" (click)="delete()" class="page-button mt-3 mb-0 mr-3" nbButtonToggle nbButton size="large" shape="round" outline status="danger">
          <nb-icon icon="trash-2-outline" class="mr-2"></nb-icon> Delete
        </button>
        <button (click)="save()" class="full-button page-button mt-3 mb-0" fullWidth nbButton size="large" shape="round" outline status="primary">
          <nb-icon icon="plus-outline" class="mr-2"></nb-icon>Save Connection
        </button>
      </div>

    </nb-card-body>
  </nb-card>
